import React, { useState } from "react";
import SchoolMS_FAQs from "../../ServiceDetails/Faq/Faq"


const AccordionItem = ({ question, answer, isOpen, onClick }) => {
    return (
      <div className="accordion-item">
        <div className="accordion-header" id={question}>
          <button
            className={`accordion-button ${isOpen ? "" : "collapsed"}`}
            type="button"
            onClick={onClick}
            aria-expanded={isOpen}
            aria-controls={question}
          >
            <span className="title">{question}</span>
          </button>
        </div>
        <div
          id={question}
          className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
          aria-labelledby={question}
        >
          <div className="accordion-body">{answer}</div>
        </div>
      </div>
    );
  };

const SchoolMS_FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

  const items = [
    {
      question: "What is the Reels App?",
      answer:
        "The Reels App is a platform to create, edit, and share short, engaging videos with a global audience.",
    },
    {
      question: "Can I add music to my reels?",
      answer:
        "Yes, the app provides a vast library of trending music and sound effects to enhance your videos.",
    },
    {
      question: "Are there editing tools available in the app?",
      answer:
        "Absolutely! The app includes features like filters, transitions, text overlays, and more for professional-quality videos.",
    },
    {
      question: "Can I collaborate with other creators?",
      answer:
        "Yes, you can collaborate using features like duet or remix to create content with other users on the platform.",
    },
    {
      question: "Is the app free to use?",
      answer:
        "Yes, the app is free with optional premium features available for advanced tools and ad-free experiences.",
    },
  ];

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
    

  return (
    <div className="section harsafe-choose-us-section-02 section-padding">
      <div className="container">
        {/* <!-- Pricing Wrap Start --> */}
        <div className="pricing-wrap">
          <div className="section-title text-center">
            <h3 className="sub-title">FAQ</h3>
            <h2 className="title">FAQ's</h2>
          </div>
          <div className="pricing-content-wrap">
            <div className="col-lg-8 col-md-12 m-auto">

              <div className="choose-us-right">
                <div className="faq-accordion">
                  <div className="accordion" id="accordionExample">
                    {items.map((item, index) => (
                      <AccordionItem
                        key={index}
                        question={item.question}
                        answer={item.answer}
                        isOpen={activeIndex === index}
                        onClick={() => handleClick(index)}
                      />
                    ))}
                  </div>
                </div>
              </div>
              

            </div>
          </div>
        </div>
        {/* <!-- Pricing Wrap End --> */}
      </div>
    </div>
  )
}

export default SchoolMS_FAQ